import { defineMessages } from 'react-intl';

export const gatewayMessages = defineMessages({
    gateways: {
        id: 'gateways',
        defaultMessage: 'Gateways',
    },
    gateway: {
        id: 'gateway',
        defaultMessage: 'Gateway',
    },
    entryZone: {
        id: 'entry-zone',
        defaultMessage: 'Entry zone',
    },
    exitZone: {
        id: 'exit-zone',
        defaultMessage: 'Exit zone',
    },
    deleteGatewaySubtitle: {
        id: 'delete-gateway-subtitle',
        defaultMessage: 'Permanently delete gateway {entry}',
    },
    confirmDeleteGateway: {
        id: 'confirm-delete-gateway',
        defaultMessage: 'Are you sure you want to delete gateway {entry}? This action cannot be undone.',
    },
    deleteGatewaySuccess: {
        id: 'delete-gateway-success',
        defaultMessage: 'Gateway deleted',
    },
    deleteGatewaySuccessDescription: {
        id: 'delete-gateway-success-description',
        defaultMessage: 'Gateway {entry} has been successfully deleted.',
    },
    createGatewaySuccess: {
        id: 'create-gateway-success',
        defaultMessage: 'Gateway created',
    },
    createGatewaySuccessDescription: {
        id: 'create-gateway-success-description',
        defaultMessage: 'Gateway {entry} has been successfully created.',
    },
    addGatewaySubtitle: {
        id: 'add-gateway-subtitle',
        defaultMessage: 'Create a new gateway',
    },
    licensePlate: {
        id: 'license-plate',
        defaultMessage: 'License plate',
    },
    ticket: {
        id: 'ticket',
        defaultMessage: 'Ticket',
    },
    accessKey: {
        id: 'access-key',
        defaultMessage: 'Access key',
    },
    requiredIdentifiers: {
        id: 'required-identifiers',
        defaultMessage: 'Required identifiers',
    },
    updateGatewaySuccess: {
        id: 'update-gateway-success',
        defaultMessage: 'Gateway updated',
    },
    updateGatewaySuccessDescription: {
        id: 'update-gateway-success-description',
        defaultMessage: 'Gateway {entry} has been successfully updated.',
    },
    editGatewaySubtitle: {
        id: 'edit-gateway-subtitle',
        defaultMessage: 'Edit gateway {entry}',
    },
    gatewayPoint: {
        id: 'gateway-point',
        defaultMessage: 'Gateway',
    },
    gatewayPoints: {
        id: 'gateway-points',
        defaultMessage: 'Gateways',
    },
    allowUnknownMainIdentifier: {
        id: 'allow-unknown-main-identifier',
        defaultMessage: 'Allow unknown main identifier',
    },
    requireAllIdentifier: {
        id: 'require-all-identifier',
        defaultMessage: 'Require all identifier',
    },
});
